/**
 * The one way to build an in-app link to a proposal (FND-23, OD-60).
 *
 * Proposal v2 is the only proposal UI, so every entry lands on
 * `/proposal/:id/v2/<section>`. `id` is a raw (unencoded) project id and is
 * encoded here; `section` may contain `/` (`sources/pricing`) or a query
 * (`home?submission=s1`) and is passed through unencoded.
 */ export function proposalHref(id, section = 'home') {
    return `/proposal/${encodeURIComponent(id)}/v2/${section}`;
}
